/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Colour_CombinationInputs */

const en_field_colour_combination = /** @type {(inputs: Field_Colour_CombinationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colour combination`)
};

/**
* | output |
* | --- |
* | "Colour combination" |
*
* @param {Field_Colour_CombinationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const field_colour_combination = /** @type {((inputs?: Field_Colour_CombinationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Colour_CombinationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_field_colour_combination(inputs)
});